import React from "react";
import { useSelector } from "react-redux";
import styles from "./FlooringColorsMenu.module.css";
import color from './assets/color.svg';

const FlooringColorsMenu = ({ handleColorFamilySelect }) => {
  const flooringColors = useSelector((state) => state.visualizer.flooringColors);

  const colors =
    flooringColors && flooringColors.length ? (
      flooringColors.map((obj, index) => (
        <div key={index} onClick={() => handleColorFamilySelect(obj)}>

          <div>
            <img src={`https://renderfarm2.chameleonpower.com/proxy/getImage.ashx?spec=!${obj.id}&type=prod&extra=(focus=500)&Size=250`} alt={obj.style} />
          </div>
          <p>{obj.style}</p>

        </div>
      ))
    ) : (
      <li>No colors available</li>
    );

    return (
      <>
        <div className={styles.heading}>
        <img src={color} alt="color icon" height="25" width="auto"/>
          <h3>Shop by Color</h3>
        </div>
        <div className={styles.FlooringColorsMenu}>
          {colors}
        </div>
      </>
    );
};

export default FlooringColorsMenu;
